var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00039 8.3502C1.25481 8.3502 0.650391 7.74578 0.650391 7.0002C0.650391 6.25461 1.25481 5.6502 2.00039 5.6502C2.74598 5.6502 3.35039 6.25461 3.35039 7.0002C3.35039 7.74578 2.74598 8.3502 2.00039 8.3502Z",
    fill: "#798B99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00039 13.3002C1.25481 13.3002 0.650391 12.6958 0.650391 11.9502C0.650391 11.2046 1.25481 10.6002 2.00039 10.6002C2.74598 10.6002 3.35039 11.2046 3.35039 11.9502C3.35039 12.6958 2.74597 13.3002 2.00039 13.3002Z",
    fill: "#798B99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00039 3.4002C1.25481 3.4002 0.650391 2.79578 0.650391 2.0502C0.650391 1.30461 1.25481 0.700195 2.00039 0.700195C2.74598 0.700195 3.35039 1.30461 3.35039 2.0502C3.35039 2.79578 2.74598 3.4002 2.00039 3.4002Z",
    fill: "#798B99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionIcon);
export default __webpack_public_path__ + "static/media/option_icon.93cbbca395c98a19d9f441de0f893cba.svg";
export { ForwardRef as ReactComponent };